/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

export const DEFAULT_HIGHLIGHT_COLOR = 'rgba(238, 245, 40, 0.5)';
export const DEFAULT_HIGHLIGHT_PADDING = 0;
